var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          attrs: {
            shadow: "never",
            "body-style": { padding: "20px 20px 2px" },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "用户昵称/评论内容" },
                    model: {
                      value: _vm.query.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "星级" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "form_content_width",
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.query.star,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "star", $$v)
                        },
                        expression: "query.star",
                      },
                    },
                    _vm._l(5, function (star) {
                      return _c("el-option", {
                        key: star,
                        attrs: { label: star + " 星", value: star },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "回复状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "form_content_width",
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.query.isReply,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "isReply", $$v)
                        },
                        expression: "query.isReply",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未回复", value: false },
                      }),
                      _c("el-option", {
                        attrs: { label: "已回复", value: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.search } },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "mt14",
          attrs: { shadow: "never", "body-style": { padding: "20px" } },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["distribution:store:product:reply:virtual"],
                  expression: "['distribution:store:product:reply:virtual']",
                },
              ],
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.openVirtual },
            },
            [_vm._v(" 添加虚拟评论 ")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt20",
              attrs: { data: _vm.rows, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "productId", label: "商品ID", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "规格", "min-width": "110" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: "评论人",
                  "min-width": "110",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "星级", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-rate", {
                          attrs: { value: scope.row.star, disabled: "" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "comment",
                  label: "评论内容",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantReplyContent",
                  label: "回复内容",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(scope.row.merchantReplyContent || "-")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "评论时间", width: "170" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "130", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.isReply
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "distribution:store:product:reply:comment",
                                    ],
                                    expression:
                                      "['distribution:store:product:reply:comment']",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.reply(scope.row)
                                  },
                                },
                              },
                              [_vm._v("回复")]
                            )
                          : _vm._e(),
                        !scope.row.isReply
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" },
                            })
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:product:reply:delete",
                                ],
                                expression:
                                  "['distribution:store:product:reply:delete']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.query.limit,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加虚拟评论",
            visible: _vm.visible,
            width: "620px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.clearForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品", prop: "productId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "请选择门店商品" },
                      model: {
                        value: _vm.form.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "productId", $$v)
                        },
                        expression: "form.productId",
                      },
                    },
                    _vm._l(_vm.products, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.name + "（ID:" + item.id + "）",
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论人", prop: "nickname" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "30" },
                    model: {
                      value: _vm.form.nickname,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "nickname",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.nickname",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "星级", prop: "star" } },
                [
                  _c("el-rate", {
                    model: {
                      value: _vm.form.star,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "star", $$v)
                      },
                      expression: "form.star",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规格" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "128", placeholder: "可选" },
                    model: {
                      value: _vm.form.sku,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "sku",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.sku",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论内容", prop: "comment" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.comment,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "comment",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submitVirtual },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }